export default __webpack_public_path__ + "de8c1a8fd6526ba6c64bf55466d01558.svg";